import {ChangeDetectionStrategy, Component} from '@angular/core';
import {OrganizationSelectors} from '@store/store.selectors';
import {SelectPipeModule} from '../shared/pipes/select-pipe/select-pipe.module';

@Component({
  selector: 'rn-library-policy',
  templateUrl: './library-policy.component.html',
  styles: `
    .term-container {
      overflow: auto;
      max-width: 60vw;
      max-height: 80vh;
      margin: 1.5rem;
    }

    .term-title {
      margin: 0;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipeModule]
})
export class LibraryPolicyComponent {
  public readonly organizationSelectors = OrganizationSelectors.Auth;
}
